<div class="block-text-modal">
    <h1 mat-dialog-title>{{ data.title | translate }}</h1>
    <mat-dialog-content class="modal-content">
        <div class="data-string" [innerHTML]="data.text | translate"></div>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-action">
        <button mat-raised-button color="primary" [mat-dialog-close]="">{{ 'button_ok' | translate }}</button>
    </mat-dialog-actions>
</div>
